import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const AsyncComponentLoading = ({
  minHeight,
  LoadingIndicator = /*#__PURE__*/_jsx(UILoadingSpinner, {
    "data-test-id": "async-component-loading",
    grow: true,
    minHeight: minHeight
  })
}) => {
  return LoadingIndicator;
};
AsyncComponentLoading.displayName = 'AsyncComponentLoading';
export default AsyncComponentLoading;